module.exports = __webpack_public_path__ + "img/21.33439ccf.png";